import axios from "../../../axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { createAsyncThunk } from "@reduxjs/toolkit";

/**
 * Login User
 * @param {form} payload
 */
export const login = async (payload) => {
  try {
    const { data } = await axios.post("/auth/login", payload);

    //
    let token = data.result.access_token;
    let user = data.result.userInfo;

    //
    localStorage.setItem("token", token);

    //
    return user;
  } catch (error) {
    return false;
  }
};

/**
 * Register User
 * @param {form} payload
 */
export const register = async (payload) => {
  try {
    const { data } = await axios.post("/auth/register", payload);

    //
    let token = data.result.access_token;
    let user = data.result.userInfo;

    //
    localStorage.setItem("token", token);

    //
    return user;
  } catch (error) {
    return false;
  }
};

/**
 * Register User
 * @param {token} payload
 */
export const googleLogin = async (payload) => {
  try {
    const { data } = await axios.post("/auth/google/login", payload);

    //
    let token = data.result.access_token;
    let user = data.result.userInfo;

    //
    localStorage.setItem("token", token);

    //
    return user;
  } catch (error) {
    return false;
  }
};

/**
 * Register User
 * @param {token} payload
 */
export const appleLogin = async (payload) => {
  try {
    const { data } = await axios.post("/auth/apple/login", payload);

    //
    let token = data.result.access_token;
    let user = data.result.userInfo;

    //
    localStorage.setItem("token", token);

    //
    return user;
  } catch (error) {
    return false;
  }
};

/**
 * Recover Password
 * @param {form} payload
 */
export const recovery = async (payload) => {
  try {
    const { data } = await axios.post("auth/forget-password", payload);

    //
    let message = data.result;

    //
    toast.success(message, {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Get User
 */
export const getUser = createAsyncThunk("getUser", async () => {
  try {
    const { data } = await axios.get("/users/profile");

    //
    let { user, products } = data.result;

    //
    return { user, products };
  } catch (error) {
    return false;
  }
});

/**
 * Update User Profile
 * @param {username, first_name, last_name} payload
 */
export const updateProfile = async (payload) => {
  try {
    const { data } = await axios.patch("users/profile/update", payload);

    //
    let user = data.result;

    //
    toast.success("Profile Updated", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    //
    return user;
  } catch (error) {
    return false;
  }
};

/**
 * Update User Photo
 * @param {*} payload
 */
export const updatePhoto = async (payload) => {
  try {
    const { data } = await axios.post("/users/profile/upload-photo", payload);

    //
    let user = data.result;

    //
    return user;
  } catch (error) {
    return false;
  }
};

/**
 * Logout User
 */
export const logoutUser = async () => {
  try {
    await axios.post("/auth/logout");

    //
    localStorage.removeItem("token");

    //
    window.location = "/#/auth";

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Resend Verify Email
 */
export const resendVarifyEmail = async () => {
  try {
    await axios.get("auth/verify/resend");

    //
    toast.success("Verify Email Sent", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Change Password
 * @param {form} payload
 */
export const changePassword = async (payload) => {
  try {
    await axios.put("/auth/change-password", payload);

    //
    toast.success("Password Updated", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Check Exist Email
 * @param {email} payload
 */
export const existEmail = async (payload) => {
  try {
    await axios.post("/auth/check-email-exists", payload);

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Update Email
 * @param {email, password} payload
 */
export const changeEmail = async (payload) => {
  try {
    await axios.patch("/users/profile/change-email", payload);

    //
    toast.success("Email Updated", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Activate User
 * @param {id , token} payload
 */
export const activateUser = async (payload) => {
  try {
    await axios.get("auth/verify/token", {
      params: {
        token: payload,
      },
    });

    //
    toast.success("Profile Activated , Redirect to login", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Reset Password
 * * @param {{password} , token} payload
 */
export const resetPassword = async (payload) => {
  try {
    await axios.post(`/auth/reset-password/${payload.token}`, payload.content);

    //
    toast.success("Password changed , Redirect to login", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Generate New Telegram Code
 */
export const generateTelegramCode = async () => {
  try {
    const { data } = await axios.post("/notifications/telegram/generate-code");

    //
    let code = data.result;

    //
    return code;
  } catch (error) {
    return false;
  }
};

/**
 * Send Invite Link
 * @param {fd} payload
 */
export const sendInviteLink = async (payload) => {
  try {
    await axios.post("/affiliate/invite", payload);

    //
    toast.success("Invitation email sent", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Get Invitaions List
 */
export const getInvitaions = async () => {
  try {
    const { data } = await axios.get("/users/referrals/list");

    //
    let list = data.result;

    //
    return list;
  } catch (error) {
    return false;
  }
};

/**
 * Get Earnings
 */
export const getEarnings = async () => {
  try {
    const { data } = await axios.get("/users/referrals/earning-list");

    //
    let list = data.result;

    //
    return list;
  } catch (error) {
    return false;
  }
};

/**
 * Change Earning Type
 * @param {type: fiat || point} payload
 */
export const changeEarningType = createAsyncThunk(
  "changeEarningType",
  async (payload) => {
    try {
      await axios.patch("/users/referrals/change-type", payload);

      //
      let type = payload.type;

      //
      return type;
    } catch (error) {
      return false;
    }
  }
);

/**
 * Cancel Auto Renew
 */
export const cancelAutoRenew = createAsyncThunk("cancelAutoRenew", async () => {
  try {
    await axios.delete("/subscriptions/cancel");

    //
    return true;
  } catch (error) {
    return false;
  }
});

/**
 * Get Notifications
 * @param {page, perPage} payload
 */
export const getNotifications = createAsyncThunk(
  "getNotifications",
  async (payload) => {
    try {
      const { data } = await axios.get("/notifications", {
        params: {
          page: payload.page,
          perPage: payload.perPage,
        },
      });

      //
      let list = data.data;

      //
      return list;
    } catch (error) {
      return false;
    }
  }
);

/**
 * Delete Notifications
 */
export const deleteNotifications = createAsyncThunk(
  "deleteNotifications",
  async () => {
    try {
      await axios.post("/notifications/clear");

      //
      return true;
    } catch (error) {
      return false;
    }
  }
);

/**
 * Send Player Id
 */
export const sendPlayerID = async (payload) => {
  try {
    await axios.post("notifications/setUser", payload);

    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Contact Us
 */
export const contactUs = async (payload) => {
  try {
    await axios.post("contact-us", payload);

    //
    toast.success("Your request has been successfully sent", {
      theme: "colored",
      icon: <i className="las la-bell toast_icons"></i>,
      closeButton: (
        <i className="las la-times-circle toast_close_button toast_icons"></i>
      ),
    });

    //
    return true;
  } catch (error) {
    return false;
  }
};
